import React, { Component } from 'react';
import PropTypes from 'prop-types';
import NavbarDark from './NavbarDark';
import Navbar from './Navbar';

class NavbarManager extends Component {
  showNavbarDark = () => (
    <NavbarDark flagImageUrl={this.props.flagImageUrl} location={this.props.location}/>
  );

  showNavbarNormal = () => (
    <Navbar
      sideBarOpen={this.props.sideBarOpen}
      toggleSidebar={this.props.toggleSidebar}
      languages={this.props.languages}
      shouldPushHeaderDown={this.props.shouldPushHeaderDown}
      headerTopPx={this.props.headerTopPx}
    />
  );

  render() {
    const showDarkNavbar = (this.props.location.pathname.includes('/checkout'));
    return (
      showDarkNavbar ?
        this.showNavbarDark() :
        this.showNavbarNormal()
    );
  }
}

NavbarManager.defaultProps = {
  showDarkNavbar: false,
};

NavbarManager.propTypes = {
  sideBarOpen: PropTypes.bool.isRequired,
  toggleSidebar: PropTypes.func.isRequired,
};

export default NavbarManager;



// WEBPACK FOOTER //
// ./src/Nav/NavbarManager.js